import request from "@/utils/request";

export function germinatedSeedBagGet(params) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/Get",
        method: "GET",
        params
    });
}

export function germinatedSeedBagGetAll(params) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/GetAll",
        method: "GET",
        params
    });
}


export function germinatedSeedBagGetAllForDropdown(data) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/GetAllForDropdown",
        method: "GET",
        data
    });
}

export function createGerminatedSeedBag(data) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/Create",
        method: "POST",
        data
    });
}

export function createManyGerminatedSeedBag(data) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/CreateMany",
        method: "POST",
        data
    });
}

export function updateGerminatedSeedBag(data) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/Update",
        method: "PUT",
        data
    });
}

export function patchGerminatedSeedBag(data) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/Patch",
        method: "PATCH",
        data
    });
}
export function patchManyGerminatedSeedBag(data) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/PatchMany",
        method: "PATCH",
        data
    });
}

export function deleteGerminatedSeedBag(params) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/Delete",
        method: "DELETE",
        params
    });
}

export function deleteManyGerminatedSeedBag(data) {
    return request({
        url: "/api/services/app/GerminatedSeedBag/DeleteMany",
        method: "POST",
        data
    });
}



// WEBPACK FOOTER //
// ./src/api/germinated_seed_bag.js